/* ==========================================================================
   BeBroot Premium — Product page behaviour
   Gallery, lightbox, sticky add-to-cart, offers, read more, floating video.
   Plain JS, no dependencies. Hooks into the theme via window.themeCore.EventBus.
   ========================================================================== */
(function () {
	'use strict';

	var desktopMQ = window.matchMedia('(min-width: 990px)');
	var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');

	function onThemeReady(cb) {
		if (window.themeCore && window.themeCore.loaded && window.themeCore.EventBus) {
			cb();
		} else {
			document.addEventListener('theme:all:loaded', cb, { once: true });
		}
	}

	function isVisible(el) {
		return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
	}

	/* ------------------------------------------------------------------
	   Gallery
	------------------------------------------------------------------ */
	function Gallery(root) {
		this.root = root;
		this.track = root.querySelector('.js-bb-track');
		if (!this.track) return;
		this.slides = Array.prototype.slice.call(root.querySelectorAll('.js-bb-slide'));
		this.thumbs = Array.prototype.slice.call(root.querySelectorAll('.js-bb-thumb'));
		this.thumbsTrack = root.querySelector('.js-bb-thumbs');
		this.dots = Array.prototype.slice.call(root.querySelectorAll('.js-bb-dot'));
		this.current = root.querySelector('.js-bb-current');
		this.index = 0;
		this.lightbox = new Lightbox(root.querySelector('.js-bb-lightbox'));
		this.bind();

		var startIndex = this.indexOfMedia(root.dataset.startMediaId);
		if (startIndex > 0) this.goTo(startIndex, false);
		this.listenVariants();
		this.autoRotate();
	}

	/* Auto-rotate images every 4s. Stops for good once the shopper interacts
	   (swipe, thumbnail, arrow, zoom); pauses off-screen / background tab / video
	   playing; never runs with reduced motion. */
	Gallery.prototype.autoRotate = function () {
		var self = this;
		if (this.slides.length < 2 || reduceMotion.matches) return;
		var stopped = false, visible = false, programmatic = false;
		var stop = function () { stopped = true; };
		this.root.addEventListener('pointerdown', stop);
		this.root.addEventListener('touchstart', stop, { passive: true });
		this.root.addEventListener('keydown', stop);
		this.track.addEventListener('scroll', function () { if (!programmatic) stop(); }, { passive: true });
		if ('IntersectionObserver' in window) {
			new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.6 }).observe(this.track);
		} else { visible = true; }
		setInterval(function () {
			if (stopped || !visible || document.hidden) return;
			if (self.root.querySelector('.js-bb-video.is-playing')) return;
			programmatic = true;
			self.step(1);
			setTimeout(function () { programmatic = false; }, 900);
		}, 4000);
	};

	Gallery.prototype.indexOfMedia = function (mediaId) {
		if (!mediaId) return -1;
		for (var i = 0; i < this.slides.length; i++) {
			if (String(this.slides[i].dataset.mediaId) === String(mediaId)) return i;
		}
		return -1;
	};

	Gallery.prototype.bind = function () {
		var self = this;
		var frame = null;

		this.track.addEventListener('scroll', function () {
			if (frame) cancelAnimationFrame(frame);
			frame = requestAnimationFrame(function () {
				var width = self.track.clientWidth || 1;
				var i = Math.round(Math.abs(self.track.scrollLeft) / width);
				if (i !== self.index) self.setActive(i);
			});
		}, { passive: true });

		var prev = this.root.querySelector('.js-bb-prev');
		var next = this.root.querySelector('.js-bb-next');
		if (prev) prev.addEventListener('click', function () { self.step(-1); });
		if (next) next.addEventListener('click', function () { self.step(1); });

		this.thumbs.forEach(function (thumb) {
			thumb.addEventListener('click', function () { self.goTo(parseInt(thumb.dataset.index, 10)); });
		});

		this.track.addEventListener('keydown', function (e) {
			if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
			if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
		});

		/* video slides */
		this.root.querySelectorAll('.js-bb-play').forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.stopPropagation();
				self.playVideo(btn.closest('.js-bb-video'));
			});
		});

		/* open lightbox */
		this.root.querySelectorAll('.js-bb-open-lightbox').forEach(function (trigger) {
			trigger.addEventListener('click', function () {
				if (trigger.dataset.bbDragged === '1') return;
				var id = trigger.dataset.mediaId;
				if (!id) {
					var slide = self.slides[self.index];
					id = slide && slide.dataset.mediaId;
				}
				self.lightbox.open(id);
			});
		});

		/* desktop hover zoom */
		this.slides.forEach(function (slide) {
			var img = slide.querySelector('.js-bb-zoom-img');
			if (!img) return;
			slide.addEventListener('mousemove', function (e) {
				if (!hoverMQ.matches || !desktopMQ.matches) return;
				var rect = slide.getBoundingClientRect();
				var x = ((e.clientX - rect.left) / rect.width) * 100;
				var y = ((e.clientY - rect.top) / rect.height) * 100;
				img.style.transformOrigin = x + '% ' + y + '%';
				slide.classList.add('is-zooming');
			});
			slide.addEventListener('mouseleave', function () {
				slide.classList.remove('is-zooming');
				img.style.transformOrigin = '';
			});
		});

		window.addEventListener('resize', function () {
			self.goTo(self.index, false);
		});
	};

	Gallery.prototype.step = function (delta) {
		var total = this.slides.length;
		this.goTo((this.index + delta + total) % total);
	};

	Gallery.prototype.goTo = function (i, smooth) {
		if (i < 0 || i >= this.slides.length) return;
		var left = i * this.track.clientWidth;
		if (smooth === false) {
			var prevBehavior = this.track.style.scrollBehavior;
			this.track.style.scrollBehavior = 'auto';
			this.track.scrollLeft = left;
			this.track.style.scrollBehavior = prevBehavior;
		} else {
			this.track.scrollTo({ left: left, behavior: 'smooth' });
		}
		this.setActive(i);
	};

	Gallery.prototype.setActive = function (i) {
		if (i < 0 || i >= this.slides.length) return;
		var previous = this.index;
		this.index = i;

		this.thumbs.forEach(function (t, n) {
			var on = n === i;
			t.classList.toggle('is-active', on);
			if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
		});
		this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
		if (this.current) this.current.textContent = String(i + 1);

		/* keep the active thumbnail in view inside the rail only (never scroll the page) */
		var activeThumb = this.thumbs[i];
		if (activeThumb && this.thumbsTrack) {
			var tt = this.thumbsTrack;
			if (tt.scrollWidth > tt.clientWidth + 1) {
				// horizontal strip (phones)
				var left = activeThumb.offsetLeft;
				if (left < tt.scrollLeft || left + activeThumb.offsetWidth > tt.scrollLeft + tt.clientWidth) {
					tt.scrollTo({ left: left - tt.clientWidth / 2 + activeThumb.offsetWidth / 2, behavior: 'smooth' });
				}
			} else {
				var top = activeThumb.offsetTop;
				if (top < tt.scrollTop || top + activeThumb.offsetHeight > tt.scrollTop + tt.clientHeight) {
					tt.scrollTo({ top: top - tt.clientHeight / 2 + activeThumb.offsetHeight / 2, behavior: 'smooth' });
				}
			}
		}

		if (previous !== i) this.pauseVideos(i);
		var slide = this.slides[i];
		if (slide && slide.dataset.mediaType === 'video') {
			var box = slide.querySelector('.js-bb-video');
			if (box && !box.classList.contains('is-playing')) this.playVideo(box);
		}
	};

	Gallery.prototype.playVideo = function (box) {
		if (!box) return;
		var tpl = box.querySelector('template');
		if (tpl && !box.dataset.loaded) {
			box.appendChild(tpl.content.cloneNode(true));
			box.dataset.loaded = '1';
		}
		box.classList.add('is-playing');
		var video = box.querySelector('video');
		if (video) {
			video.muted = true;
			video.setAttribute('playsinline', '');
			var p = video.play();
			if (p && p.catch) p.catch(function () {});
		}
	};

	Gallery.prototype.pauseVideos = function (activeIndex) {
		this.slides.forEach(function (slide, n) {
			if (n === activeIndex) return;
			var video = slide.querySelector('video');
			if (video && !video.paused) video.pause();
			var iframe = slide.querySelector('iframe');
			if (iframe && iframe.contentWindow) {
				try {
					iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
					iframe.contentWindow.postMessage('{"method":"pause"}', '*');
				} catch (e) {}
			}
		});
	};

	Gallery.prototype.listenVariants = function () {
		var self = this;
		var sectionId = this.root.dataset.sectionId;
		onThemeReady(function () {
			if (!window.themeCore || !window.themeCore.EventBus) return;
			window.themeCore.EventBus.listen('pdp:section-' + sectionId + ':change-variant', function (data) {
				var variant = data && data.variant;
				if (!variant || !variant.featured_media) return;
				var i = self.indexOfMedia(variant.featured_media.id);
				if (i > -1 && i !== self.index) self.goTo(i);
			});
		});
	};

	/* ------------------------------------------------------------------
	   Lightbox
	------------------------------------------------------------------ */
	function Lightbox(dialog) {
		this.dialog = dialog;
		if (!dialog) return;
		this.track = dialog.querySelector('.js-bb-lb-track');
		this.slides = Array.prototype.slice.call(dialog.querySelectorAll('.js-bb-lb-slide'));
		this.thumbs = Array.prototype.slice.call(dialog.querySelectorAll('.js-bb-lb-thumb'));
		this.counter = dialog.querySelector('.js-bb-lb-current');
		this.index = 0;
		if (dialog.parentNode !== document.body) document.body.appendChild(dialog);
		this.bind();
	}

	Lightbox.prototype.bind = function () {
		var self = this;
		var frame = null;

		this.dialog.querySelector('.js-bb-lb-close').addEventListener('click', function () { self.close(); });
		this.dialog.addEventListener('close', function () { self.cleanup(); });
		this.dialog.addEventListener('cancel', function () { self.cleanup(); });

		var prev = this.dialog.querySelector('.js-bb-lb-prev');
		var next = this.dialog.querySelector('.js-bb-lb-next');
		if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
		if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });

		this.thumbs.forEach(function (t, n) {
			t.addEventListener('click', function () { self.goTo(n); });
		});

		this.dialog.addEventListener('keydown', function (e) {
			if (e.key === 'ArrowRight') self.goTo(self.index + 1);
			if (e.key === 'ArrowLeft') self.goTo(self.index - 1);
		});

		this.track.addEventListener('scroll', function () {
			if (frame) cancelAnimationFrame(frame);
			frame = requestAnimationFrame(function () {
				var i = Math.round(Math.abs(self.track.scrollLeft) / (self.track.clientWidth || 1));
				if (i !== self.index) self.setActive(i);
			});
		}, { passive: true });

		/* tap / click to zoom at the pointer position */
		this.slides.forEach(function (slide) {
			var img = slide.querySelector('.js-bb-lb-img');
			if (!img) return;
			var downX = 0, downY = 0;
			slide.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; });
			slide.addEventListener('click', function (e) {
				if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) return;
				if (slide.classList.contains('is-zoomed')) {
					slide.classList.remove('is-zoomed');
					self.track.classList.remove('is-locked');
					return;
				}
				var rect = img.getBoundingClientRect();
				var rx = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
				var ry = Math.min(Math.max((e.clientY - rect.top) / rect.height, 0), 1);
				slide.classList.add('is-zoomed');
				self.track.classList.add('is-locked');
				requestAnimationFrame(function () {
					slide.scrollLeft = rx * slide.scrollWidth - slide.clientWidth / 2;
					slide.scrollTop = ry * slide.scrollHeight - slide.clientHeight / 2;
				});
			});
		});
	};

	Lightbox.prototype.open = function (mediaId) {
		if (!this.dialog) return;
		var index = 0;
		for (var i = 0; i < this.slides.length; i++) {
			if (String(this.slides[i].dataset.mediaId) === String(mediaId)) { index = i; break; }
		}
		if (typeof this.dialog.showModal === 'function') {
			this.dialog.showModal();
		} else {
			this.dialog.setAttribute('open', '');
		}
		document.documentElement.classList.add('bb-lock');
		var self = this;
		requestAnimationFrame(function () { self.goTo(index, false); });
	};

	Lightbox.prototype.close = function () {
		if (typeof this.dialog.close === 'function') this.dialog.close();
		else this.dialog.removeAttribute('open');
		this.cleanup();
	};

	Lightbox.prototype.cleanup = function () {
		document.documentElement.classList.remove('bb-lock');
		this.slides.forEach(function (s) { s.classList.remove('is-zoomed'); });
		if (this.track) this.track.classList.remove('is-locked');
	};

	Lightbox.prototype.goTo = function (i, smooth) {
		var total = this.slides.length;
		if (!total) return;
		i = (i + total) % total;
		this.slides.forEach(function (s) { s.classList.remove('is-zoomed'); });
		this.track.classList.remove('is-locked');
		var left = i * this.track.clientWidth;
		if (smooth === false) {
			this.track.style.scrollBehavior = 'auto';
			this.track.scrollLeft = left;
			this.track.style.scrollBehavior = '';
		} else {
			this.track.scrollTo({ left: left, behavior: 'smooth' });
		}
		this.setActive(i);
	};

	Lightbox.prototype.setActive = function (i) {
		this.index = i;
		if (this.counter) this.counter.textContent = String(i + 1);
		this.thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
	};

	/* ------------------------------------------------------------------
	   Sticky add to cart
	------------------------------------------------------------------ */
	function initSticky() {
		var sticky = document.querySelector('.js-bb-sticky');
		if (!sticky) return;
		var form = sticky.closest('form');
		if (!form) return;
		var mainBtn = form.querySelector('.product-add-to-cart [type="submit"]:not(.js-sticky-add-to-cart-button)');
		var mobileMQ = window.matchMedia('(max-width: 989px)');
		var mainInView = true;
		var scrolledPast = false;
		var docEl = document.documentElement;

		/* The bar stays inside the product form so the theme keeps its price,
		   disabled and loading states in sync with the selected variant. */
		function measure() {
			docEl.style.setProperty('--bb-sticky-h', sticky.offsetHeight + 'px');
		}

		function update() {
			var show = mobileMQ.matches ? !mainInView : scrolledPast;
			if (!mainBtn) show = window.scrollY > 400;
			sticky.classList.toggle('bb-show', show);
			document.body.classList.toggle('bb-sticky-on', show);
			if (show) measure();
		}

		if (mainBtn && 'IntersectionObserver' in window) {
			new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					mainInView = entry.isIntersecting;
					scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
				});
				update();
			}).observe(mainBtn);
		} else {
			window.addEventListener('scroll', update, { passive: true });
		}
		mobileMQ.addEventListener ? mobileMQ.addEventListener('change', update) : mobileMQ.addListener(update);
		window.addEventListener('resize', measure);

		/* Buy now: reuse whichever fast checkout the main form is showing (Shiprocket in India,
		   Shopify dynamic checkout elsewhere), otherwise fall back to add to cart. */
		var buy = sticky.querySelector('.js-bb-sticky-buy');
		if (buy) {
			buy.addEventListener('click', function () {
				if (mainBtn && mainBtn.disabled) return;
				var candidates = form.querySelectorAll('.shiprocket-headless button, .sr-headless-checkout, .shopify-payment-button__button');
				for (var i = 0; i < candidates.length; i++) {
					if (isVisible(candidates[i]) && !candidates[i].disabled) {
						candidates[i].click();
						return;
					}
				}
				if (mainBtn) mainBtn.click();
			});

			/* mirror the disabled state of the add to cart button */
			var atc = sticky.querySelector('.js-sticky-add-to-cart-button');
			if (atc && 'MutationObserver' in window) {
				new MutationObserver(function () { buy.disabled = atc.disabled; })
					.observe(atc, { attributes: true, attributeFilter: ['disabled'] });
			}
		}
	}

	/* ------------------------------------------------------------------
	   Offers: copy code
	------------------------------------------------------------------ */
	function initCopy() {
		document.addEventListener('click', function (e) {
			var btn = e.target.closest('.js-bb-copy');
			if (!btn) return;
			var code = btn.dataset.code || '';
			var label = btn.querySelector('.bb-coupon__copy-label');
			var done = function () {
				btn.classList.add('is-copied');
				if (label) label.textContent = 'Copied';
				setTimeout(function () {
					btn.classList.remove('is-copied');
					if (label) label.textContent = 'Copy';
				}, 2200);
			};
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(code).then(done, done);
			} else {
				var ta = document.createElement('textarea');
				ta.value = code;
				ta.setAttribute('readonly', '');
				ta.style.position = 'fixed';
				ta.style.opacity = '0';
				document.body.appendChild(ta);
				ta.select();
				try { document.execCommand('copy'); } catch (err) {}
				document.body.removeChild(ta);
				done();
			}
		});
	}

	/* ------------------------------------------------------------------
	   Read more
	------------------------------------------------------------------ */
	function initReadMore() {
		document.querySelectorAll('.js-bb-readmore').forEach(function (wrap) {
			var content = wrap.querySelector('.bb-readmore__content');
			var toggle = wrap.querySelector('.js-bb-readmore-toggle');
			var label = wrap.querySelector('.js-bb-readmore-label');
			if (!content || !toggle) return;
			wrap.classList.add('is-clamped');
			if (content.scrollHeight <= content.clientHeight + 24) {
				wrap.classList.remove('is-clamped');
				return;
			}
			toggle.addEventListener('click', function () {
				var open = wrap.classList.toggle('is-open');
				toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
				if (label) label.textContent = open ? 'Read less' : 'Read more';
			});
		});
	}

	/* ------------------------------------------------------------------
	   Jump nav: sticky under the header, sliding indicator, scroll spy
	------------------------------------------------------------------ */
	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	// where each pill points: first match wins, its enclosing section is the target
	var TARGETS = {
		benefits: '[id*="__tab_slider"], .tab-slider-container',
		expect: '.bb-timeline',
		ingredients: '.bb-ingredients',
		ritual: '.bb-ritual',
		reviews: '[id*="app_block_review_list"], [id*="app-block-review-list"]',
		faq: '[id*="__faq_simple"], .faq-simple'
	};

	function findTarget(key) {
		var sel = TARGETS[key];
		if (!sel) return null;
		var el = document.querySelector(sel);
		if (!el) return null;
		return el.closest('.shopify-section') || el;
	}

	var headerEl = null;
	function headerBottom() {
		if (!headerEl || !headerEl.isConnected) {
			var inner = document.querySelector('header.header, header');
			// the sticky element is the section wrapper around <header>
			headerEl = inner ? (inner.closest('.shopify-section') || inner) : null;
		}
		var h = headerEl;
		if (!h) return 0;
		var r = h.getBoundingClientRect();
		return Math.max(0, Math.round(r.bottom));
	}

	function scrollToEl(el, extra) {
		var y = el.getBoundingClientRect().top + window.pageYOffset - headerBottom() - (extra || 0) - 8;
		window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
	}

	function initJumpNav() {
		var nav = document.querySelector('.js-bb-jnav');
		var wrap = nav && nav.closest('.shopify-section');
		if (!nav || !wrap || nav.dataset.bbInit) return;
		nav.dataset.bbInit = '1';
		wrap.classList.add('bb-jnav-host');

		var list = nav.querySelector('.js-bb-jnav-list');
		var indicator = nav.querySelector('.js-bb-jnav-indicator');
		var links = Array.prototype.slice.call(nav.querySelectorAll('.js-bb-jnav-link'));
		var pairs = [];

		links.forEach(function (link) {
			var target = findTarget(link.dataset.target);
			if (!target) { link.parentElement.hidden = true; return; }
			if (!target.id || target.id.indexOf('bb-') !== 0) target.setAttribute('data-bb-anchor', link.dataset.target);
			// keep #bb-reviews etc. working for in-page links (rating in the buy box)
			if (!document.getElementById('bb-' + link.dataset.target)) {
				var anchor = document.createElement('span');
				anchor.id = 'bb-' + link.dataset.target;
				anchor.className = 'bb-anchor';
				target.insertBefore(anchor, target.firstChild);
			}
			pairs.push({ link: link, target: target });
			link.addEventListener('click', function (e) {
				e.preventDefault();
				scrollToEl(target, nav.offsetHeight);
			});
		});
		if (!pairs.length) { wrap.hidden = true; return; }

		var active = null;
		function moveIndicator(link) {
			if (!indicator || !link) return;
			indicator.style.width = link.offsetWidth + 'px';
			indicator.style.transform = 'translateX(' + link.offsetLeft + 'px)';
			indicator.classList.add('is-on');
			// keep the active pill in view on narrow screens
			var l = link.offsetLeft - 16, r = link.offsetLeft + link.offsetWidth + 16;
			if (l < list.scrollLeft || r > list.scrollLeft + list.clientWidth) {
				list.scrollTo({ left: l, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
			}
		}
		function setActive(pair) {
			if (active === pair) return;
			active = pair;
			pairs.forEach(function (p) {
				var on = p === pair;
				p.link.classList.toggle('is-active', on);
				if (on) p.link.setAttribute('aria-current', 'true'); else p.link.removeAttribute('aria-current');
			});
			if (pair) moveIndicator(pair.link);
			else if (indicator) indicator.classList.remove('is-on');
		}

		var ticking = false;
		function update() {
			ticking = false;
			var top = headerBottom();
			wrap.style.setProperty('--bb-jnav-top', top + 'px');
			var stuck = wrap.getBoundingClientRect().top <= top + 1;
			wrap.classList.toggle('is-stuck', stuck);
			// back in the page flow: show the row from its first pill again
			if (!stuck && list.scrollLeft > 0) list.scrollTo({ left: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
			// active = last target whose top has passed the nav line
			var line = top + nav.offsetHeight + 24;
			var current = null;
			for (var i = 0; i < pairs.length; i++) {
				if (pairs[i].target.getBoundingClientRect().top <= line) current = pairs[i];
			}
			setActive(stuck ? (current || pairs[0]) : null);
		}
		function onScroll() {
			if (!ticking) { ticking = true; requestAnimationFrame(update); }
		}
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', function () { if (active) moveIndicator(active.link); onScroll(); });
		update();
	}

	/* rating link in the buy box and any other in-page "#bb-…" jump */
	document.addEventListener('click', function (e) {
		var a = e.target.closest && e.target.closest('.js-bb-jump');
		if (!a) return;
		var id = (a.getAttribute('href') || '').replace('#', '');
		var el = id && document.getElementById(id);
		if (!el) return;
		e.preventDefault();
		var nav = document.querySelector('.js-bb-jnav');
		scrollToEl(el, nav ? nav.offsetHeight : 0);
	});

	/* ------------------------------------------------------------------
	   Key benefits: show all / fewer
	------------------------------------------------------------------ */
	function initHighlights() {
		document.querySelectorAll('.js-bb-highlights').forEach(function (box) {
			var btn = box.querySelector('.js-bb-hl-toggle');
			if (!btn || btn.dataset.bbInit) return;
			btn.dataset.bbInit = '1';
			var label = btn.querySelector('.js-bb-hl-label');
			btn.addEventListener('click', function () {
				var open = box.classList.toggle('is-open');
				btn.setAttribute('aria-expanded', open ? 'true' : 'false');
				if (label) label.textContent = open ? label.dataset.open : label.dataset.closed;
			});
		});
	}

	/* ------------------------------------------------------------------
	   Offer price follows the selected variant
	------------------------------------------------------------------ */
	function initOfferPrice() {
		var box = document.querySelector('.js-bb-offerprice');
		var section = box && box.closest('[data-section-id]');
		if (!box || !section) return;
		var value = box.querySelector('.js-bb-offerprice-value');
		var keep = parseInt(box.dataset.keep, 10) || 90;
		onThemeReady(function () {
			if (!window.themeCore || !window.themeCore.EventBus) return;
			window.themeCore.EventBus.listen('pdp:section-' + section.dataset.sectionId + ':change-variant', function (data) {
				var v = data && data.variant;
				if (!v || typeof v.price !== 'number' || !value) return;
				var rupees = Math.round((v.price * keep) / 10000);
				value.textContent = '₹' + rupees.toLocaleString('en-IN');
			});
		});
	}

	/* ------------------------------------------------------------------
	   Offers: hide scheduled offers outside their dates (India time, so a
	   cached page never shows an expired offer), "Ends in 2 days" on the
	   last days, and the "Add 2 to cart" button follows the variant
	------------------------------------------------------------------ */
	function initOfferSchedule() {
		var box = document.querySelector('.js-bb-offers');
		if (!box) return;
		var ist = new Date(Date.now() + 330 * 60000);
		var today = parseInt(ist.toISOString().slice(0, 10).replace(/-/g, ''), 10);
		var dayMs = 86400000;
		var toTime = function (ymd) {
			return Date.UTC(Math.floor(ymd / 10000), Math.floor(ymd / 100) % 100 - 1, ymd % 100);
		};

		box.querySelectorAll('.js-bb-coupon').forEach(function (card) {
			var start = parseInt(card.dataset.start, 10) || 0;
			var end = parseInt(card.dataset.end, 10) || 0;
			if ((start && today < start) || (end && today > end)) {
				card.remove();
				return;
			}
			var ends = card.querySelector('.js-bb-coupon-ends-text');
			if (!end || !ends) return;
			var left = Math.round((toTime(end) - toTime(today)) / dayMs);
			if (left === 0) ends.textContent = 'Ends today';
			else if (left === 1) ends.textContent = 'Ends tomorrow';
			else if (left <= 3) ends.textContent = 'Ends in ' + left + ' days';
		});

		var left = box.querySelectorAll('.js-bb-coupon').length;
		if (!left) { box.remove(); return; }
		var count = box.querySelector('.js-bb-offers-count');
		if (count) {
			count.textContent = left + ' offers';
			count.hidden = left < 2;
		}
		var track = box.querySelector('.bb-offers__track');
		if (track) track.classList.toggle('bb-offers__track--single', left === 1);
		initPairQuantity(box);

		var follow = box.querySelectorAll('.js-bb-follow-variant');
		var section = box.closest('[data-section-id]');
		if (!follow.length || !section) return;
		onThemeReady(function () {
			if (!window.themeCore || !window.themeCore.EventBus) return;
			window.themeCore.EventBus.listen('pdp:section-' + section.dataset.sectionId + ':change-variant', function (data) {
				var v = data && data.variant;
				if (!v || !v.id) return;
				follow.forEach(function (btn) {
					btn.dataset.variantId = v.id;
					btn.disabled = v.available === false;
				});
			});
		});
	}

	/* ------------------------------------------------------------------
	   Offers: while a live "Add 2 to cart" (Buy 1 Get 1) card is on the page,
	   Add to cart, the sticky bar and Buy now all add 2. The theme form,
	   Shiprocket and Shopify's buy button read the form's quantity and fall
	   back to 1 (the quantity block is off), so the form gets a hidden
	   quantity=2, reset just before every add in case something changed it.
	------------------------------------------------------------------ */
	function initPairQuantity(box) {
		var pair = box.querySelector('.js-bb-add[data-quantity="2"]');
		var form = document.querySelector('.product-add-to-cart .shiprocket-headless, .product-add-to-cart [type="submit"]');
		form = form && form.closest('form');
		if (!pair || !form) return;
		if (form.querySelector('input[name="quantity"]:not([type="hidden"])')) return;
		var qty = document.createElement('input');
		qty.type = 'hidden';
		qty.name = 'quantity';
		var reset = function () {
			qty.value = pair.dataset.quantity;
			if (qty.parentNode !== form) form.appendChild(qty);
		};
		reset();
		document.addEventListener('click', function (e) {
			if (e.target && e.target.closest && form.contains(e.target)) reset();
		}, true);
		form.addEventListener('submit', reset, true);
	}

	/* ------------------------------------------------------------------
	   Boot
	------------------------------------------------------------------ */
	function boot() {
		document.querySelectorAll('.js-bb-gallery').forEach(function (el) {
			if (!el.dataset.bbInit) { el.dataset.bbInit = '1'; new Gallery(el); }
		});
		initSticky();
		initCopy();
		initReadMore();
		initHighlights();
		initOfferPrice();
		initOfferSchedule();
		// app blocks (reviews) render their wrapper server-side, so targets exist now
		initJumpNav();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}

	/* theme editor: re-init sections when they reload */
	document.addEventListener('shopify:section:load', function (e) {
		var scope = e.target;
		scope.querySelectorAll('.js-bb-gallery').forEach(function (el) { new Gallery(el); });
	});
})();
